export const ensureHasLeadingSlash = basePath => {
  if (!basePath) {
    return '';
  }

  if (basePath.startsWith('/')) {
    return basePath;
  }

  return `/${basePath}`;
};
